import React from 'react'

export const DetailedItemList = (): JSX.Element => {
  return <div>items</div>
}
